module.exports = __webpack_public_path__ + "img/catarinas_y_sprockets.520b5747.jpg";